import { UserTypes } from 'types/GlobalTypes';

export const StatusCodes = {
  Success: 200,
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  InternalServerError: 500,
};

export const TypeColorsDictionary: Record<UserTypes | string, string> = {
  admin: 'black',
  analyst: 'dark-periwinkle',
  scout: 'kermit-green',
  trainer: 'ballPlayerBLue',
  coach: 'sky-blue',
  player: 'orange',
  stadiumtagger: 'stadiumTagger',
  cloudlivedashboard: 'cloudLiveDashboard',
  user: 'reddish-pink',
  other: 'reddish-pink',

  // status
  active: 'success',
  pending: 'primary',
  pendinguseraction: 'primary',
  pendingappsetup: 'primary',
  pendingemailsend: 'primary',
  inactive: 'secondary',
  abandoned: 'secondary',
  finalized: 'black',
};

export const ServiceTypes = {
  ErrorHandler: Symbol('ErrorHandler'),
  ConfigurationService: Symbol('ConfigurationService'),
  AuthenticationService: Symbol('AuthenticationService'),
  apiServiceAxiosInstance: Symbol('apiServiceAxiosInstance'),
};

export const EmptyGuid = '00000000-0000-0000-0000-000000000000';

export const LicenseTypes = ['PracticeProduct', 'NCAA', 'Umpire'];

export const LicensesFeatures = {
  PracticeProduct: [
//    'LiveMeasurements',
    'Trajectory',
    'BetaFirmware',
    'UserTracking',
    'HighspeedCamera',
//    'UseEvents',
    'CustomOverlayLogo',
//    'PracticeReports_1_1',
//    'El1Subsidiary'
  ],
  NCAA: [
    'UserTracking',
    'SharedNetworkAccess',
//    'RecruitReport15U',
//    'RecruitReport16U',
//    'TeamExclusive',
//    'SystemV3',
//    'StadiumPlayerReports',
//    'PlayerTrackingReport',
//    'StadiumReports_1_1'
  ],
  Umpire: [
    'UmpireManagement',
//    'UmpireSharedNetworkAccess',
//    'UmpireAdminReport',
//    'UmpireOwningOrgReport',
//    'UmpireIndividualUmpReport'
  ],
  DataIntegration: [
    'DataApi'
  ]
};

export const ReportPermissions = [
  "BTPS.Admin@",
  "BTPS.Analyst@",
  "BTPS.Coach@",
  "BTPS.Player@",
  "BTPS.Scout@",
  "BTPS.Umpire@"
];